import { Component, OnInit, Input } from '@angular/core';

import { AppComponent } from '../app.component';
import { ViewEncapsulation } from '@angular/core'

@Component({
  standalone: false,
  selector: 'pnl-default-unbordered',
  templateUrl: './z-pnl-default-unbordered.component.html',
  styleUrls: ['./z-pnl-default-unbordered.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class pnlDefaultUnbordered implements OnInit {

  @Input() aPanelData: any;

  constructor( public app: AppComponent ) { }

  ngOnInit() {
  }

}
